module.exports = __webpack_public_path__ + "img/Каменная стая.197d2aea.svg";